import React from 'react';
import PropTypes from 'prop-types';

import { default as content } from '../AddNewPayeeLandingPage/index.content';
import { Input } from '../../../sharedComponents/Form';
import { countries } from '../../../config';
import { validationPropsProtoTypes, addressFieldPropTypes } from '../../states/addPayee/propTypes';

const AddressForm = ({ validationProps, addressLine1, addressLine2, city, postalCode, country }) => {
	const { addressLine1Label, addressLine2Label, cityLabel, postalCodeLabel, countryLabel } = content;
	return (
		<span>
			<addressLine1.component {...addressLine1} label={addressLine1Label} type="text" {...validationProps} />
			<Input {...addressLine2} label={addressLine2Label} type="text" onChange={validationProps.onChange} />
			<city.component {...city} label={cityLabel} type="text" {...validationProps} />
			<Input {...postalCode} label={postalCodeLabel} type="text" onChange={validationProps.onChange} />
			<country.component {...country} label={countryLabel} options={countries} type="text" {...validationProps} />
		</span>
	);
};

AddressForm.propTypes = {
	addressLine1: PropTypes.shape(addressFieldPropTypes).isRequired,
	addressLine2: PropTypes.shape(addressFieldPropTypes).isRequired,
	city: PropTypes.shape(addressFieldPropTypes).isRequired,
	postalCode: PropTypes.shape(addressFieldPropTypes).isRequired,
	country: PropTypes.shape(addressFieldPropTypes).isRequired,
	validationProps: PropTypes.shape(validationPropsProtoTypes).isRequired,
};

export default AddressForm;
